import { CreateSector, EstadisticasSector, Sector, UpdateSector } from '../../models/Entities/Turnero';
import { ErrorType } from '../../models/HttpError';

export const TURNERO_SECTORES_GET_ALL_REQUEST = 'TURNERO-SECTORES_GET_ALL_REQUEST';
export const TURNERO_SECTORES_GET_ALL_SUCCESS = 'TURNERO-SECTORES_GET_ALL_SUCCESS';
export const TURNERO_SECTORES_GET_ALL_FAILURE = 'TURNERO-SECTORES_GET_ALL_FAILURE';

export interface TurneroSectoresGetAllRequestAction {
    type: typeof TURNERO_SECTORES_GET_ALL_REQUEST;
}

export interface TurneroSectoresGetAllSuccessAction {
    type: typeof TURNERO_SECTORES_GET_ALL_SUCCESS;
    payload: Sector[];
}

export interface TurneroSectoresGetAllFailureAction {
    type: typeof TURNERO_SECTORES_GET_ALL_FAILURE;
    error: ErrorType;
}

export const TURNERO_SECTORES_CREATE_REQUEST = 'TURNERO-SECTORES_CREATE_REQUEST';
export const TURNERO_SECTORES_CREATE_SUCCESS = 'TURNERO-SECTORES_CREATE_SUCCESS';
export const TURNERO_SECTORES_CREATE_FAILURE = 'TURNERO-SECTORES_CREATE_FAILURE';

export interface TurneroSectoresCreateRequestAction {
    type: typeof TURNERO_SECTORES_CREATE_REQUEST;
    payload: CreateSector;
}

export interface TurneroSectoresCreateSuccessAction {
    type: typeof TURNERO_SECTORES_CREATE_SUCCESS;
    payload: Sector;
}

export interface TurneroSectoresCreateFailureAction {
    type: typeof TURNERO_SECTORES_CREATE_FAILURE;
    error: ErrorType;
}

export const TURNERO_SECTORES_GET_BY_ID_REQUEST = 'TURNERO-SECTORES_GET_BY_ID_REQUEST';
export const TURNERO_SECTORES_GET_BY_ID_SUCCESS = 'TURNERO-SECTORES_GET_BY_ID_SUCCESS';
export const TURNERO_SECTORES_GET_BY_ID_FAILURE = 'TURNERO-SECTORES_GET_BY_ID_FAILURE';

export interface TurneroSectoresGetByIdRequestAction {
    type: typeof TURNERO_SECTORES_GET_BY_ID_REQUEST;
    sectorId: number;
}

export interface TurneroSectoresGetByIdSuccessAction {
    type: typeof TURNERO_SECTORES_GET_BY_ID_SUCCESS;
    sectorId: number;
    payload: Sector;
}

export interface TurneroSectoresGetByIdFailureAction {
    type: typeof TURNERO_SECTORES_GET_BY_ID_FAILURE;
    sectorId: number;
    error: ErrorType;
}

export const TURNERO_SECTORES_UPDATE_REQUEST = 'TURNERO-SECTORES_UPDATE_REQUEST';
export const TURNERO_SECTORES_UPDATE_SUCCESS = 'TURNERO-SECTORES_UPDATE_SUCCESS';
export const TURNERO_SECTORES_UPDATE_FAILURE = 'TURNERO-SECTORES_UPDATE_FAILURE';

export interface TurneroSectoresUpdateRequestAction {
    type: typeof TURNERO_SECTORES_UPDATE_REQUEST;
    id: number;
    payload: UpdateSector;
}

export interface TurneroSectoresUpdateSuccessAction {
    type: typeof TURNERO_SECTORES_UPDATE_SUCCESS;
    id: number;
    payload: UpdateSector;
}

export interface TurneroSectoresUpdateFailureAction {
    type: typeof TURNERO_SECTORES_UPDATE_FAILURE;
    id: number;
    error: ErrorType;
}

export const TURNERO_SECTORES_DELETE_REQUEST = 'TURNERO-SECTORES_DELETE_REQUEST';
export const TURNERO_SECTORES_DELETE_SUCCESS = 'TURNERO-SECTORES_DELETE_SUCCESS';
export const TURNERO_SECTORES_DELETE_FAILURE = 'TURNERO-SECTORES_DELETE_FAILURE';

export interface TurneroSectoresDeleteRequestAction {
    type: typeof TURNERO_SECTORES_DELETE_REQUEST;
    id: number;
}

export interface TurneroSectoresDeleteSuccessAction {
    type: typeof TURNERO_SECTORES_DELETE_SUCCESS;
    payload: number;
}

export interface TurneroSectoresDeleteFailureAction {
    type: typeof TURNERO_SECTORES_DELETE_FAILURE;
    id: number;
    error: ErrorType;
}

export const TURNERO_SECTORES_GET_ESTADISTICAS_REQUEST = 'TURNERO-SECTORES_GET_ESTADISTICAS_REQUEST';
export const TURNERO_SECTORES_GET_ESTADISTICAS_SUCCESS = 'TURNERO-SECTORES_GET_ESTADISTICAS_SUCCESS';
export const TURNERO_SECTORES_GET_ESTADISTICAS_FAILURE = 'TURNERO-SECTORES_GET_ESTADISTICAS_FAILURE';

export interface TurneroSectoresGetEstadisticasRequestAction {
    type: typeof TURNERO_SECTORES_GET_ESTADISTICAS_REQUEST;
    sectorId: number;
}

export interface TurneroSectoresGetEstadisticasSuccessAction {
    type: typeof TURNERO_SECTORES_GET_ESTADISTICAS_SUCCESS;
    sectorId: number;
    payload: EstadisticasSector;
}

export interface TurneroSectoresGetEstadisticasFailureAction {
    type: typeof TURNERO_SECTORES_GET_ESTADISTICAS_FAILURE;
    sectorId: number;
    error: ErrorType;
}
